.styledInput {
  width: 0;
  flex-grow: 1;

  input {
    width: 0;
    text-align: left;
  }

  [data-input-wrapper] > span {
    color: var(--text-soft);
  }

  &.textAlignRight input {
    text-align: right;
  }
}
